import React from "react"

import { InputDigits } from "@atos6/components"
import { digitsOnly } from "@atos6/utils"
import { useStore } from "../containers"

export function InputAccountNumberStateful() {
  const { accountNumber, setState } = useStore()

  return (
    <InputDigits
      placeholder="Número da Conta"
      maxLength={12}
      value={digitsOnly(accountNumber)}
      onChange={accountNumber => setState({ accountNumber })}
    />
  )
}
